"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachFileAnswer = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const featureFlags_1 = require("../../../../common/featureFlags");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const AttachFileAnswerStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
	justify-content: center;
	width: 100%;

	.attach-file-column {
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isMobile ? '12px' : '20px')};
		align-items: center;
		justify-content: center;
	}

	.attach-file-answer {
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		gap: 12px;
	}

	.attach-file-box-render {
		display: flex;
		flex-direction: row;
		gap: 16px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.label {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);
			letter-spacing: var(--h5-letter-spacing, -0.02em);
			font-weight: var(--h5-font-weight, 700);
			position: relative;
			width: 32px;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.attach-file-box {
			background: var(--color-white, #ffffff);
			border-radius: 4px;
			padding: 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			height: 50px;
			position: relative;
			overflow: hidden;

			.btn-file {
				background: var(--color-white, #ffffff);
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 10px;
				display: flex;
				flex-direction: row;
				gap: 10px;
				align-items: center;
				justify-content: flex-start;
				flex: 1;
				height: 50px;
				position: relative;
				overflow: hidden;

				.button {
					overflow: hidden;

					svg {
						min-width: 20px;
					}
				}
			}
		}
		.attachment-button-container {
			width: ${props => (props.$isMobile ? '64px' : '80px')};
			display: flex;
			flex-direction: row;
			gap: 16px;
		}
	}
`;
// 첨부 파일 컴포넌트
exports.AttachFileAnswer = react_1.default.memo(({ attachFileList, setAttachFileList, isRegist, showRegist = false, isAnswer = false, isTeacher, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const fileRef = react_1.default.useRef(null);
    const [fileBoxes, setFileBoxes] = react_1.default.useState(attachFileList.length > 0
        ? Array.from({ length: attachFileList.length }, (_, i) => i)
        : [0]);
    const acceptedFileTypes = 'image/*,application/pdf,.xlsx, .xls, .csv, .ppt, .pptx, .pdf, .doc, .docx, .txt, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain, video/mp4, .mp4, ' +
        (featureFlags_1.MP3_FEATURE_ENABLED ? 'audio/mpeg, .mp3, ' : '') +
        '.zip, application/zip, application/x-zip-compressed';
    react_1.default.useEffect(() => {
        setFileBoxes(attachFileList.length > 0
            ? Array.from({ length: attachFileList.length }, (_, i) => i)
            : [0]);
    }, [attachFileList]);
    const downloadFile = (url) => {
        const formattedUrl = url.replace(/\s/g, '%20');
        const a = document.createElement('a');
        a.href = formattedUrl;
        a.download = url.split('/').pop() || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    // 파일 추가 처리
    const onChangeFile = (e, index) => {
        const file = e.target.files ? e.target.files[0] : null;
        if (file) {
            const updatedList = [...attachFileList];
            updatedList[index] = file;
            setAttachFileList && setAttachFileList(updatedList);
        }
        if (fileRef.current)
            fileRef.current.value = '';
    };
    // 새로운 파일 박스 추가
    const addNewBox = () => {
        setFileBoxes(prev => [...prev, prev.length]);
        const updatedList = [...attachFileList];
        updatedList.push(null);
        setAttachFileList && setAttachFileList(updatedList);
    };
    // 파일 박스 삭제
    const deleteBox = (index) => {
        // 파일 리스트에서 해당 인덱스의 파일 제거
        const updatedList = attachFileList.filter((_, i) => i !== index);
        setAttachFileList && setAttachFileList(updatedList);
        // fileBoxes 재정렬 (0부터 순차적으로)
        const updatedBoxes = Array.from({ length: fileBoxes.length - 1 }, (_, i) => i);
        setFileBoxes(updatedBoxes);
    };
    const handleDrop = e => {
        e.preventDefault();
        alert('폴더를 등록할 수 없습니다.');
    };
    const handleDragOver = e => {
        e.preventDefault();
    };
    const renderAttachFileButton = (index) => (react_1.default.createElement(common_1.FileInput, { ref: fileRef, id: `dst_attach_file_${index}`, onChange: (e) => onChangeFile(e, index), accept: acceptedFileTypes },
        react_1.default.createElement(common_1.Button, { option: {
                buttonBeforeIcon: {
                    name: 'add_folder',
                    color: Colors_1.Colors.dark_tur,
                    size: isMobile ? 24 : 32,
                    show: true,
                },
            } })));
    const renderActionButtons = (index) => {
        const isLastBox = index === fileBoxes[fileBoxes.length - 1];
        const hasFile = attachFileList[index] != null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            isLastBox && hasFile && (react_1.default.createElement(common_1.Button, { option: {
                    buttonBeforeIcon: {
                        name: 'add_ring',
                        color: Colors_1.Colors.dark_tur,
                        size: isMobile ? 24 : 32,
                        show: true,
                    },
                }, onClick: addNewBox })),
            hasFile && (react_1.default.createElement(common_1.Button, { option: {
                    buttonBeforeIcon: {
                        name: 'minus_ring',
                        color: Colors_1.Colors.dark_tur,
                        size: isMobile ? 24 : 32,
                        show: true,
                    },
                }, onClick: () => deleteBox(index) }))));
    };
    const renderAttachFile = (index) => {
        const file = attachFileList[index];
        return (react_1.default.createElement("div", { key: index, className: "attach-file-box-render" },
            react_1.default.createElement("p", { className: "label" }, index + 1),
            react_1.default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, className: "attach-file-box" },
                react_1.default.createElement("div", { className: "btn-file" }, file ? (react_1.default.createElement(common_1.Button, { className: `btn btn_sliver md_round body5 cursor  ${isMobile ? 'mobile-xxs' : ''}`, text: typeof file === 'string'
                        ? file.split('/')[file.split('/').length - 1]
                        : file.name, styles: {
                        buttonWrap: {
                            height: 'fit-content',
                        },
                    }, option: {
                        buttonBeforeIcon: {
                            name: 'file',
                            color: Colors_1.Colors.dark_tur,
                            size: isMobile ? 12 : 20,
                            show: true,
                        },
                        buttonAfterIcon: {
                            name: !showRegist && !isAnswer && typeof file === 'string'
                                ? 'file-down'
                                : '',
                            color: Colors_1.Colors.accent,
                            size: !showRegist && !isAnswer && typeof file === 'string'
                                ? 16
                                : 12,
                            show: showRegist || isAnswer
                                ? true
                                : typeof file === 'string',
                        },
                    }, onClick: !showRegist && typeof file === 'string'
                        ? () => downloadFile(file)
                        : () => { } })) : (react_1.default.createElement("p", { className: "body5 noAttachFilePlaceholer", style: { color: Colors_1.Colors.light_grey, width: '100%' } }, isTeacher && isRegist
                    ? t('assignment.attachFilePlaceholer')
                    : t('assignment.noAttachFilePlaceholer'))))),
            react_1.default.createElement("div", { className: "attachment-button-container" },
                showRegist && !file && renderAttachFileButton(index),
                showRegist && renderActionButtons(index))));
    };
    return (react_1.default.createElement(AttachFileAnswerStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "attach-file-answer" },
            !isTeacher ? (react_1.default.createElement("div", { className: "task-label" }, isRegist
                ? t('assignment.attachFilePlaceholer')
                : t('assignment.attachFile'))) : (react_1.default.createElement("div", { className: "hr" })),
            react_1.default.createElement("div", { className: "attach-file-column" }, fileBoxes.map(index => renderAttachFile(index))))));
});
